import React, { useEffect, useState } from "react";

/**
 * Khung xem thử landing page ở kích thước điện thoại.
 * Debounce 500ms để gõ/dán HTML dài không dựng lại iframe liên tục.
 * Sandbox giống trang thật bên web (không allow-same-origin).
 */
function LandingPagePreview({ html }) {
    const [debounced, setDebounced] = useState(html);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(html), 500);
        return () => clearTimeout(timer);
    }, [html]);

    return (
        <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold">Xem thử (khung điện thoại)</label>
            <div className="border border-line rounded-xl overflow-hidden bg-surface-sunken flex justify-center p-3">
                {debounced?.trim() ? (
                    <iframe
                        title="Xem thử trang"
                        srcDoc={debounced}
                        sandbox="allow-scripts allow-forms allow-popups"
                        style={{ width: 390, height: 720, border: "1px solid rgb(var(--line))", borderRadius: 12, background: "#fff" }}
                    />
                ) : (
                    <div className="text-content-3 text-sm py-20">Dán HTML để xem thử</div>
                )}
            </div>
        </div>
    );
}

export default LandingPagePreview;
